import { render, staticRenderFns } from "./preText.vue?vue&type=template&id=c91c83b8&"
import script from "./preText.vue?vue&type=script&lang=js&"
export * from "./preText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports